'use client';

import { type ReactNode } from 'react';
import { Box, HStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Text } from '../../components/styled/text';
import { MarkdownPreview } from '../markdown-preview';

export type EvidenceCardMissingProps = {
  explanation?: string;
  actions?: ReactNode;
};

export function EvidenceCardMissing({
  explanation,
  actions,
}: EvidenceCardMissingProps) {
  const t = useTranslations('designSystem.findings.structuredPocEditor');

  if (!explanation) {
    return null;
  }

  return (
    <Box
      w="full"
      borderWidth="1px"
      borderColor="border.subtle"
      borderRadius="md"
      overflow="hidden"
      bg="bg.canvas"
    >
      {actions ? (
        <HStack
          px={3}
          py={2}
          bg="bg.subtle"
          justifyContent="space-between"
          borderBottomWidth="1px"
          borderColor="border.subtle"
        >
          <Text fontSize="xs" fontWeight="medium" color="fg.default">
            {t('evidence')}
          </Text>
          {actions}
        </HStack>
      ) : null}
      <Box px={3} py={2} color="fg.default">
        <MarkdownPreview source={explanation} fontSize={12} compact />
      </Box>
    </Box>
  );
}
